import { BroadbandQaFailedContent } from "../BroadbandQaFailedContent/BroadbandQaFailedContent";
import { BroadbandOtherErrorContent } from "../BroadbandOtherErrorContent/BroadbandOtherErrorContent";

interface IErrorUanHandlerProps {
    hasQaFailedError: boolean;
    hasOtherError: boolean;
    shouldShowErrorContent: boolean;
    onRetry?(): void;
    onChangeUan?(): void;
    onRemove?(): void;
}

export const ErrorUANHandler = (props: IErrorUanHandlerProps) => {
    const { hasQaFailedError, hasOtherError, shouldShowErrorContent, onRetry, onChangeUan, onRemove } = props;

    if (!shouldShowErrorContent) {
        return null;
    }

    if (hasQaFailedError) {
        return <BroadbandQaFailedContent onRemove={onRemove} onRetry={onRetry} />;
    }

    if (hasOtherError) {
        return <BroadbandOtherErrorContent onChangeUan={onChangeUan} onRemove={onRemove} />;
    }

    return null;
};
